import { useMemo } from 'react';
import { useApi } from '@enuan/m3mgr-utils';
import { fetchConfig, fetchList, putConfig } from './api';
import { configurationApiMessages } from './i18n';

/**
 * Provides wrapped API methods for the chat configurator resource.
 *
 * All methods include localised error alerting and debug logging via `useApi`.
 * `updateConfiguration` issues a PUT to the model URL and works both as an
 * update and as a creation (upsert) when passed an empty configuration object.
 *
 * The returned object is memoized to keep its reference stable across renders,
 * preventing unnecessary re-renders in consumers that use it as a dependency.
 *
 * @returns Memoized object containing `fetchConfigurations`, `fetchConfiguration`,
 *   and `updateConfiguration` API helpers.
 */
export const useConfigurationApi = () => {
	const { getCollection, getModel, putModel } = useApi(
		configurationApiMessages.configurations__label,
		{
			getCollection: fetchList,
			getModel: fetchConfig,
			putModel: putConfig,
		},
	);

	return useMemo(
		() => ({
			fetchConfigurations: getCollection,
			fetchConfiguration: getModel,
			updateConfiguration: putModel,
		}),
		[getCollection, getModel, putModel],
	);
};
